import React, { useState } from 'react';

import AddControl from 'components/add_control';
import Modal from './modal';

export default function ActivityCreation() {
  const [showModal, setShowModal] = useState();

  return <>
    <AddControl onClick={() => setShowModal(true)}>Add activity</AddControl>
    <Modal show={showModal} onClose={() => setShowModal(false)} />
  </>;
}
